import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    CashOnDeliveriesExcelParams,
    CashOnDeliveriesExcelResponse,
    CashOnDeliveriesParams,
    CashOnDeliveriesResponse,
    UpdateCashOnDeliveriesPayload,
} from '../types/cash_on_deliveries.types'

export class CashOnDeliveriesRepository {
    getList(params: CashOnDeliveriesParams): Promise<AxiosResponse<CashOnDeliveriesResponse>> {
        return http.get('/cabinet/api/invoice/cash-on-deliveries', { params })
    }

    exportExcel(
        params: CashOnDeliveriesExcelParams
    ): Promise<AxiosResponse<CashOnDeliveriesExcelResponse>> {
        return http.get('/cabinet/api/invoice/cash-on-deliveries/export', {
            responseType: 'blob',
            params,
        })
    }

    updateCashOnDeliveries(payload: UpdateCashOnDeliveriesPayload): Promise<AxiosResponse<void>> {
        return http.put('/cabinet/api/invoice/cash-on-deliveries', payload)
    }
}
